(() => {
  if (customElements.get('rednib-shipping-popup')) return;

  customElements.define('rednib-shipping-popup', class extends HTMLElement {
    connectedCallback() {
      const cardScope = this.dataset.scope === 'cards';
      this.section = cardScope ? document.body : this.closest('.quickbuy-content, .section-main-product');
      this.dialog = this.querySelector('dialog');
      if (!this.section || typeof this.dialog?.showModal !== 'function') return;
      const heading = this.dialog.querySelector('.rednib-shipping-dialog__header h2');
      if (heading?.id) this.dialog.setAttribute('aria-labelledby', heading.id);

      const selector = cardScope
        ? '.product-block__price-note a[href]'
        : '.product-policies a[href], .rednib-shipping-hint a[href]';
      const policy = new URL(this.dataset.policyUrl, location.href);
      const isShippingLink = (link) => {
        const url = new URL(link.href, location.href);
        return url.origin === policy.origin && url.pathname === policy.pathname;
      };
      const markLinks = (root = this.section) => {
        const links = [...root.querySelectorAll(selector)];
        if (root.matches?.(selector)) links.push(root);
        links.forEach((link) => {
          if (isShippingLink(link)) link.setAttribute('aria-haspopup', 'dialog');
        });
      };
      this.onClick = (event) => {
        const link = event.target.closest(selector);
        if (!link || !isShippingLink(link) || event.defaultPrevented || event.button !== 0
          || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.opener = link;
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('rednib-shipping-open');
        this.dialog.querySelector('.rednib-shipping-dialog__content').scrollTop = 0;
      };
      this.onClose = () => {
        if (!document.querySelector('rednib-shipping-popup dialog[open]')) {
          document.documentElement.classList.remove('rednib-shipping-open');
        }
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      };
      this.section.addEventListener('click', this.onClick);
      this.querySelector('[data-shipping-close]').onclick = () => this.dialog.close();
      this.dialog.addEventListener('close', this.onClose);
      this.onKeyDown = (event) => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((element) => element.getClientRects().length > 0);
        const destination = event.shiftKey ? controls.at(-1) : controls[0];
        const boundary = event.shiftKey ? controls[0] : controls.at(-1);
        if (document.activeElement === boundary) {
          event.preventDefault();
          destination?.focus();
        }
      };
      this.dialog.addEventListener('keydown', this.onKeyDown);
      this.dialog.onclick = (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right
          || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      };
      this.observer = new MutationObserver((records) => {
        records.forEach((record) => record.addedNodes.forEach((node) => {
          if (node instanceof Element) markLinks(node);
        }));
      });
      this.observer.observe(this.section, { childList: true, subtree: true });
      markLinks();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.section?.removeEventListener('click', this.onClick);
      this.dialog?.removeEventListener('close', this.onClose);
      this.dialog?.removeEventListener('keydown', this.onKeyDown);
      if (this.dialog?.open) this.dialog.close();
      if (!document.querySelector('rednib-shipping-popup dialog[open]')) {
        document.documentElement.classList.remove('rednib-shipping-open');
      }
    }
  });
})();
